/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BankAccountPage = lazyLoad(
  () => import('./index'),
  module => module.BankAccountPage
);
